import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/<status>';

export function useAutomationTemplatesByStatusQuery({
	status,
	meta,
	impersonationContext,
}: {
	status: Api.TemplateStatus;
	meta?: LevStandardQueryMeta;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	const effectiveImpersonationContext = impersonationContext ?? userSession.impersonationContext;

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate`,
					queryParams: { status },
					impersonationContext: effectiveImpersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, status, effectiveImpersonationContext],
		meta,
	});
}
